<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--列表-->
    <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading" @selection-change="selsChange"
      style="width: 100%;">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column prop="OwnedCompany" label="所属公司" width="260" sortable></el-table-column>
      <el-table-column prop="uRealName" label="昵称" width="" sortable></el-table-column>
      <el-table-column prop="uLoginName" label="登录名" width="" sortable></el-table-column>
      <el-table-column prop="RoleNames" label="角色" width="" sortable>
        <template slot-scope="scope">
          <el-tag v-for="item in scope.row.RoleNames" :key="item.Id" >{{item}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="" :formatter="formatSex" sortable></el-table-column>
      <el-table-column prop="birth" label="生日" :formatter="formatBirth" width="" sortable></el-table-column>
      <el-table-column prop="uStatus" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.uStatus == 0  ? 'success' : 'danger'" disable-transitions>{{scope.row.uStatus == 0 ? "正常":"禁用"}}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50"
                      :total="total" style="float:right;">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
            <el-select style="width: 100%;" v-model="editForm.CompanyId" placeholder="请选择所属公司">
              <el-option v-for="item in companys" :key="item.Id" :value="item.Id" :label="item.CompanyName">
                <span style="float: left">{{ item.CompanyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="昵称" prop="uRealName" label-width="110px">
            <el-input v-model="editForm.uRealName" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="登录名" prop="uLoginName" label-width="110px">
            <el-input v-model="editForm.uLoginName" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="角色" prop="RIDs" label-width="110px">
            <el-select multiple v-model="editForm.RIDs" placeholder="请选择角色">
              <el-option  :key="0" :label="'未选择角色'" :value="0"></el-option>
              <el-option v-for="item in roles" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="性别" label-width="110px"> 
            <el-radio-group v-model="editForm.sex">
              <el-radio class="radio" :label="1">男</el-radio>
              <el-radio class="radio" :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="年龄" label-width="110px">
            <el-input-number v-model="editForm.age" :min="0" :max="200"></el-input-number>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="生日" label-width="110px">
            <el-date-picker type="date" placeholder="选择日期" v-model="editForm.birth"></el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="地址" label-width="110px">
            <el-input type="textarea" v-model="editForm.addr"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.CompanyId" placeholder="请选择所属公司">
              <el-option v-for="item in companys" :key="item.Id" :value="item.Id" :label="item.CompanyName">
                <span style="float: left">{{ item.CompanyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="昵称" prop="uRealName" label-width="110px">
            <el-input v-model="addForm.uRealName" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="登录名" prop="uLoginName" label-width="110px">
            <el-input v-model="addForm.uLoginName" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="密码" prop="uLoginPWD" label-width="110px">
            <el-input v-model="addForm.uLoginPWD" show-password  auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="性别" label-width="110px">
            <el-radio-group v-model="addForm.sex">
              <el-radio class="radio" :label="1">男</el-radio>
              <el-radio class="radio" :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="年龄" label-width="110px">
            <el-input-number v-model="addForm.age" :min="0" :max="200"></el-input-number>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="生日" label-width="110px">
            <el-date-picker type="date" placeholder="选择日期" v-model="addForm.birth"></el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="地址" label-width="110px">
            <el-input type="textarea" v-model="addForm.addr"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {testapi, getUserListPage,getRoleListPage, removeUser, batchRemoveUser, editUser, addUser, getCompanyListPage, verifyLoginNameExist } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    let addLoginNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.uLoginNameRules(0, value, callback);
      }
    };
    let editLoginNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.uLoginNameRules(this.editForm.uID, value, callback);
      }
    };
    return {
      filters: {
        name: ''
      },
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [],//列表选中列
      companys: [], //企业列表
      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        uLoginName: [{required: true, message: '请输入登录名', trigger: 'blur'}, { validator: editLoginNameCheck, trigger: "blur" }],
        uRealName: [{required: true, message: '请输入昵称', trigger: 'blur'}],
        birth: [{required: true, message: '请填写生日', trigger: 'blur'}]
      },
      //编辑界面数据
      editForm: {
        id: 0,
        CompanyId: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: '',
        uRealName: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      },
      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        uLoginName: [ {required: true, message: '请输入登录名', trigger: 'blur'}, { validator: addLoginNameCheck, trigger: "blur" }],
        uRealName: [{required: true, message: '请输入昵称', trigger: 'blur'}],
        uLoginPWD: [{required: true, message: '请输入密码', trigger: 'blur'}],
        birth: [{required: true, message: '请填写生日', trigger: 'blur'}]
      },
      //新增界面数据
      addForm: {
        CompanyId: 0,
        name: '',
        uLoginName: '',
        uRealName: '',
        uLoginPWD: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      }
    }
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
    },
    formatBirth: function (row, column) {
      return (!row.birth || row.birth == '') ? '' : util.formatDate.format(new Date(row.birth), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    //获取用户列表
    getUsers() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      testapi();
      getUserListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //校验登录账号是否已经存在
    uLoginNameRules(id, value, callback) {
      let para = {
        uLoginName: value,
        uID: id
      };
      verifyLoginNameExist(para).then(res => {
        if (res.data) {
          callback(new Error("登录账号已存在，请重新输入"));
        }
        callback();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
        message: "请选择要删除的一行数据！",
        type: "error"
        });

        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = {id: row.uID};
        removeUser(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.getUsers();
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
        message: "请选择要编辑的一行数据！",
        type: "error"
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);

      getRoleListPage().then((res) => {
        this.roles = res.data.response.data;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        uLoginName: '',
        uRealName: '',
        uLoginPWD: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');

            editUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getUsers();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
            addUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getUsers();
              }
              else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      var ids = this.sels.map(item => item.uID).toString();
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = {ids: ids};

        batchRemoveUser(para).then((res) => {
          this.listLoading = false;
          this.$message({
            message: '该功能未开放',
            type: 'warning'
          });
        });
      }).catch(() => {

      });
    }
  },
  mounted() {
    this.getUsers();

    getCompanyListPage().then(res => {
      this.companys = res.data.response.data;
    });

    let routers = window.localStorage.router
    ? JSON.parse(window.localStorage.router)
    : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
